<template>
  <div class="data-date">
    <div class="data-title">
      <!-- <svg v-if="reportType != 1" @click="initData" class="icon svg-icon schedule-roll-close" aria-hidden="true" style="width: 30px;height: 24px;margin-right: 12px;cursor: pointer;">
        <use xlink:href="#icon-fanhui"></use>
      </svg> -->
      <svg class="icon svg-icon schedule-roll-close" aria-hidden="true" style="width: 22px;height: 22px;">
        <use xlink:href="#icon-zhaoshengshuju"></use>
      </svg>
    </div>
    <div class="data-right">
      <div class="data-date-list" v-if="selectDateModel == 1">
        <span class="data-date-item" :class="[dateModel == item.value ? 'data-date-item-active' : '']" v-for="(item, index) in dateList" :key="index" @click="setDate(item.value)">
          {{ item.label }}
        </span>
      </div>
      <div class="data-date-list" v-if="selectDateModel == 2">
        <span class="data-date-item" :class="[dateModel2 == item.value ? 'data-date-item-active' : '']" v-for="(item, index) in dateListZ" :key="index" @click="setDateZ(item.value)">
          {{ item.label }}
        </span>
      </div>
      <div class="data-date-list" v-if="selectDateModel == 3">
        <span class="data-date-item" :class="[dateModel3 == item.value ? 'data-date-item-active' : '']" v-for="(item, index) in dateListY" :key="index" @click="setDateY(item.value)">
          {{ item.label }}
        </span>
      </div>
      <div class="data-date-list" v-if="selectDateModel == 4">
        <span class="data-date-item" :class="[dateModel4 == item.value ? 'data-date-item-active' : '']" v-for="(item, index) in dateListYear" :key="index" @click="setDateYe(item.value)">
          {{ item.label }}
        </span>
      </div>
      <el-select size="small" style="width: 80px;" v-model="selectDateModel" placeholder="">
        <el-option v-for="item in selectDate" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-date-picker
        v-if="selectDateModel == 1 || selectDateModel == 2"
        class="data-picker"
        v-model="startDateList"
        type="daterange"
        size="small"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        placeholder="选择时间范围"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="setDatePicker"
        style="max-width: 260px"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="selectDateModel == 3"
        v-model="startDateList"
        type="monthrange"
        size="small"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        format="yyyy-MM"
        value-format="yyyy-MM"
        :clearable="false"
        @change="setDatePicker"
        style="max-width: 260px"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="selectDateModel == 4"
        v-model="startDateList"
        type="monthrange"
        size="small"
        range-separator="至"
        start-placeholder="开始年份"
        end-placeholder="结束年份"
        format="yyyy-MM"
        value-format="yyyy-MM"
        :clearable="false"
        @change="setDatePicker"
        style="max-width: 260px"
      >
      </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectDate',
  data() {
    return {
      vue: this,
      timeOptionRange: '',
      selectDate: [
        { label: '按日', value: 1 },
        { label: '按周', value: 2 },
        { label: '按月', value: 3 },
        { label: '按年', value: 4 }
      ],
      dateList: [
        { label: '今日', value: 1 },
        { label: '昨日', value: 2 },
        { label: '本周', value: 3 },
        { label: '上周', value: 4 },
        { label: '本月', value: 5 },
        { label: '上月', value: 6 }
      ],
      dateListZ: [
        { label: '本周', value: 1 },
        { label: '上周', value: 2 },
        { label: '本月', value: 3 },
        { label: '上月', value: 4 },
        { label: '近6个月', value: 5 }
      ],
      dateListY: [
        { label: '本月', value: 1 },
        { label: '上月', value: 2 },
        { label: '近6个月', value: 3 },
        { label: '近一年', value: 4 }
      ],
      dateListYear: [
        { label: '本年', value: 1 },
        { label: '去年', value: 2 }
      ],
      startDateList: [],
      startDateList2: '',
      dateModel: 1, //  默认日下拉时间
      dateModel2: 2, //  默认周下拉时间
      dateModel3: 2, //  默认月下拉时间
      dateModel4: 1, //  默认年下拉时间
      selectDateModel: 1
    }
  },
  props: {
    startDateListD: {
      type: Array
    }
  },

  mounted() {
    this.startDateList = this.startDateListD
  },
  methods: {
    setDate(item) {
      this.dateModel = item
      if (this.dateModel == 1) {
        //今天
        var day = new Date() 
        var today = this.$moment(day).format("YYYY-MM-DD")
        this.$set(this.startDateList, 0, today)
        this.$set(this.startDateList, 1, today)
      } else if (this.dateModel == 2) {
        //昨天
        var yesterday = this.$moment(new Date(new Date().setDate(new Date().getDate() - 1))).format("YYYY-MM-DD")
        this.$set(this.startDateList, 0, yesterday)
        this.$set(this.startDateList, 1, yesterday)
      } else if (this.dateModel == 3) {
        //本周
        let weekday = new Date().getDay() || 7
        this.$set(this.startDateList, 0, this.$moment(new Date(new Date().setDate(new Date().getDate() - weekday + 1))).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      } else if (this.dateModel == 4) {
        //上周
        let weekday = new Date().getDay() || 7
        this.$set(this.startDateList, 0, this.$moment(new Date(new Date().setDate(new Date().getDate() - weekday - 6))).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date(new Date().setDate(new Date().getDate() - weekday))).format("YYYY-MM-DD"))
      } else if (this.dateModel == 5) {
        //本月

        // 获取当前日期
        const today = new Date();

        this.$set(this.startDateList, 0, this.$moment(new Date(today.getFullYear(), today.getMonth(), 1)).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      } else if (this.dateModel == 6) {
        //上月 第一天和最后一天
        
        // 获取当前日期
        const today = new Date();

        this.$set(this.startDateList, 0, this.$moment(new Date(today.getFullYear(), today.getMonth() - 1, 1)).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date(today.getFullYear(), today.getMonth(), 0)).format("YYYY-MM-DD"))
      }
      console.log(this.startDateList, this.selectDateModel)
      this.$emit('setDate', this.startDateList, this.selectDateModel)
    },
    setDateZ(item) {
      this.dateModel2 = item
      if (this.dateModel2 == 1) {
        //本周
        let weekday = new Date().getDay() || 7
        this.$set(this.startDateList, 0, this.$moment(new Date(new Date().setDate(new Date().getDate() - weekday + 1))).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      } else if (this.dateModel2 == 2) {
        //上周
        let weekday = new Date().getDay() || 7
        this.$set(this.startDateList, 0, this.$moment(new Date(new Date().setDate(new Date().getDate() - weekday - 6))).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date(new Date().setDate(new Date().getDate() - weekday))).format("YYYY-MM-DD"))
      } else if (this.dateModel2 == 3) {
        //本月
        const today = new Date();

        this.$set(this.startDateList, 0, this.$moment(new Date(today.getFullYear(), today.getMonth() , 1)).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      } else if (this.dateModel2 == 4) {
        //上一月第一天和最后一天
        const today = new Date();

        this.$set(this.startDateList, 0, this.$moment(new Date(today.getFullYear(), today.getMonth() - 1, 1)).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date(today.getFullYear(), today.getMonth(), 0)).format("YYYY-MM-DD"))

      } else if (this.dateModel2 == 5) {
        //近六个月
        let dt = new Date()
        dt.setMonth(dt.getMonth() - 6)
        this.$set(this.startDateList, 0, this.$moment(dt).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      }
      this.$emit('setDate', this.startDateList, this.selectDateModel)
    },
    setDateY(item) {
      this.dateModel3 = item
      if (this.dateModel3 == 1) {
        //本月
        const today = new Date();

        this.$set(this.startDateList, 0, this.$moment(new Date(today.getFullYear(), today.getMonth() , 1)).format("YYYY-MM-DD")) 
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      } else if (this.dateModel3 == 2) {
        //上一月第一天和最后一天
        
        const today = new Date();

        this.$set(this.startDateList, 0, this.$moment(new Date(today.getFullYear(), today.getMonth() - 1, 1)).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date(today.getFullYear(), today.getMonth(), 0)).format("YYYY-MM-DD"))

      } else if (this.dateModel3 == 3) {
        //近六个月
        let dt = new Date()
        dt.setMonth(dt.getMonth() - 6)
        this.$set(this.startDateList, 0, this.$moment(dt).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      } else if (this.dateModel3 == 4) {
        //一年
        let dt = new Date()
        dt.setMonth(dt.getMonth() - 12)

        this.$set(this.startDateList, 0, this.$moment(dt).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(new Date()).format("YYYY-MM-DD"))
      }

      this.$emit('setDate', this.startDateList, this.selectDateModel)
    },
    setDateYe(item) {
      this.dateModel4 = item
      if (this.dateModel4 == 1) {
        // 获取当前年份
        let currentYear = new Date().getFullYear()
        // 创建去年的第一天
        let firstDayOfLastYear = new Date(currentYear, 0, 1)
        // 获取去年的最后一天
        let lastDayOfLastYear = new Date(currentYear, 12, 0)
        //本年
        this.$set(this.startDateList, 0, this.$moment(firstDayOfLastYear).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(lastDayOfLastYear).format("YYYY-MM-DD"))
      } else if (this.dateModel4 == 2) {
        // 获取当前年份
        let currentYear = new Date().getFullYear()
        // 获取去年的年份
        let lastYear = currentYear - 1
        // 创建去年的第一天
        let firstDayOfLastYear = new Date(lastYear, 0, 1)
        // 获取去年的最后一天
        let lastDayOfLastYear = new Date(lastYear, 12, 0)
        //去年
        this.$set(this.startDateList, 0, this.$moment(firstDayOfLastYear).format("YYYY-MM-DD"))
        this.$set(this.startDateList, 1, this.$moment(lastDayOfLastYear).format("YYYY-MM-DD"))
      }
      this.$emit('setDate', this.startDateList, this.selectDateModel)
    },
    setDatePicker() {
      this.$emit('setDate', this.startDateList, this.selectDateModel)
    },
    // 获取本周时间上周下周 s代表周一 e代表周日
    _iosformDate(item) {
      return item.replace(/\//g, '-')
    },
    initData() {
      this.$emit('initData', 1)
    }
  },
  watch: {
    // 'startDateList': {
    //     handler (val) {
    //         this.$emit('setDate', val, this.selectDateModel);
    //     },
    //     deep: true
    // },
    selectDateModel(val) {
      if (val == 1) {
        this.dateModel = 1
        this.setDate(this.dateModel)
      } else if (val == 2) {
        this.dateModel2 = 1
        this.setDateZ(this.dateModel2)
      } else if (val == 3) {
        this.dateModel3 = 1
        this.setDateY(this.dateModel3)
      } else if (val == 4) {
        this.dateModel3 = 1
        this.setDateY(this.dateModel4)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-date {
  // margin: 30px 0;
  //   margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //   background: #fff;
  //   padding: 15px;
  //   border-radius: 5px;
  //   box-shadow: 0px 7px 25px 0px #e6edff;
  .data-title {
    display: flex;
    align-items: center;
    color: #333333;
    font-weight: bold;
    font-size: 16px;
    .data-name {
      margin-left: 8px;
    }
  }

  .data-right {
    display: flex;
  }

  .data-picker {
    margin-left: 10px;
  }

  .data-date-list {
    margin-right: 20px;
    .data-date-item {
      display: inline-block;
      padding: 0 10px;
      height: 32px;
      font-size: 14px;
      line-height: 32px;
      border-radius: 4px;
      text-align: center;
      margin: 0 5px;
      box-sizing: border-box;
      border: 1px solid #e0e3ea;
      cursor: pointer;
      &.data-date-item-active {
        border: 1px solid #f99f0b;
        color: #f99f0b;
      }
    }
  }
}
</style>
